import { render, staticRenderFns } from "./InventarDatatable.vue?vue&type=template&id=3cc44e37&"
import script from "./InventarDatatable.vue?vue&type=script&lang=js&"
export * from "./InventarDatatable.vue?vue&type=script&lang=js&"
import style0 from "./InventarDatatable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCheckbox,VDataTable,VIcon})
